import React from 'react';
import { TicketFooterRow } from '../TicketFooter';

function FreeTicketNg({ multiplier }) {
    return (
        <TicketFooterRow
            rowTitle={multiplier ? 'jsp.detailTiketu.volnyTiket' : 'jsp.detailTiketu.volnyTiket.withoutKurz'}
            rowInfo={multiplier}
        />
    );
}

export default FreeTicketNg;
